module.exports = {
  informations: 'informations',
  compositions: 'compositions',
  layers: 'layers',
  search_tools: 'search_tools',
  defects: 'defects'
};
